import { ref } from 'vue';
import { useResizeObserver } from '@vueuse/core';

const useTruncate = (el) => {
  const isTruncate = ref(false);
  const { stop } = useResizeObserver(el, () => {
    isTruncate.value = el.value.scrollWidth > el.value.clientWidth;
  });
  return {
    isTruncate,
    stop,
  };
};

export default useTruncate;
